module.exports = __webpack_public_path__ + "static/media/grand_mum_friend.40055bda.svg";